import type { FreelancerAddDiplomasDocumentPageLocales } from '../types';

const freelancerAddDiplomasDocumentPageLocales: FreelancerAddDiplomasDocumentPageLocales =
  {
    diplomaAdded: 'Diploma succesvol geüpload!',
    fileRequired: 'Upload een bewijs om certificaat op te slaan.',
    helperMessage:
      'Selecteer hieronder het diploma dat je wilt toevoegen. Daarna kan je het diploma uploaden.',
    noDataMessage:
      'Er is iets fout gegaan! De benodigde bronnen voor deze pagina zijn niet beschikbaar.',
    saveDiploma: 'Diploma opslaan',
    selectDiploma: 'Selecteer diploma',
    selectDocType: 'Geen diploma geselecteerd.',
    title: 'Diploma toevoegen',
    uploadProof: 'Upload bewijs (pdf)',
    wrongFileExtension:
      'Document heeft niet de juiste extensie. Upload een PDF bestand of foto.',
  };

export default freelancerAddDiplomasDocumentPageLocales;
